import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import Moment from 'react-moment';//Both are required here
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

const Participants = () => {
    const { id } = useParams();
    const [reportData, setReportData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const navigate = useNavigate();
    const api = useApi();

    const loadReport = async () => {
        await api.getReport('CurrentTraderLogin', {}).then((data) => {
            setReportData(data);
        })
    }

    useEffect(() => {
        loadReport();
    }, []);

    const dateRenderer = (props, format) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span>{cellValue ? <Moment format={format}>{cellValue}</Moment> : null}</span>
            </span>
        );
    };

    const onUpdateTraderStatus = async (traderId, status) => {
        const params = {
            traderId,
            status
        };

        await api.updateTraderStatus(params).then((response) => {
            if (response.success) {
                loadReport();
                alert(response.message);
            }
            else
                alert(response.message);

        }).catch((error) => {
            console.error('Error updating trader login:', error);
        });
    };

    const enableTraderLogin = (traderId) => {

        if (window.confirm('Are you sure you want to enable this login for current auction?') === true) {
            onUpdateTraderStatus(traderId, 1);
        }
    }
    const disableTraderLogin = (traderId) => {
        if (window.confirm('Are you sure you want to disable this login for current auction?') === true) {
            onUpdateTraderStatus(traderId, 0);
        }
    }

    const qtyRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat suffix={' Kg'} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const actionRenderer = (props) => {
        const row = props.node.data;
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                {row.IsDisabled ? <button className="btn ripple btn-success pd-x-10 mg-r-5 mg-b-4 btn-sm" type="button" onClick={() => enableTraderLogin(row.TraderId)}>
                    Enable
                </button> :
                    <button className="btn ripple btn-danger pd-x-10 mg-r-5 mg-b-4 btn-sm" type="button" onClick={() => disableTraderLogin(row.TraderId)}>
                        Disable
                    </button>}
            </span>
        );
    };

    const columns = [
        { headerName: '#', field: 'TraderId', cellClass: 'text-center', cellRenderer: (props) => { return <span>{props.rowIndex + 1}</span> },width:50 },
        { headerName: 'Name', field: 'Name', flex: 1 },
        { headerName: 'Location', field: 'Location', cellClass: 'text-center', width: 130 },
        { headerName: 'Table Number', field: 'TableNumber', cellClass: 'text-center', width: 130 },
        //{ headerName: 'Action', field: 'TraderId', cellClass: 'text-center', width: 150, cellRenderer:actionRenderer},
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        columnDefs: columns,
        //autoSizeStrategy: { type: 'fitCellContents' },
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const viewLoginHistory = () => {
        navigate(`/loginHistoryReport`);
    };
    const onGridReady = (params) => {
        setGridApi(params.api);
    };


    const exportToExcel = () => {

        const params = {
            suppressQuotes: false,
            columnSeparator: ',',
        };

        const data = gridApi.getDataAsCsv(params);

        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        const fileName = 'Auction Price Report.csv';

        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Participants</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/auctioneer')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Participants</li>
                    </ol>
                </div>
                
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>
                                </div>
                                <div>
                                    <input type="text" className="form-control" placeholder="type to filter"></input>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine"
                                }
                            >
                                <AgGridReact
                                    rowHeight={36}
                                    gridOptions={gridOptions}
                                    rowData={reportData}
                                    onGridReady={onGridReady}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Participants;



